import { Typography } from '@material-ui/core';
import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import useOpenWindow from '@swf/core/hooks/useOpenWindow';
import { translatedLink } from '@swf/core/utils';

import { AamsErrorCode } from '../../../types/status';
import Prompt from '../../Prompt/Prompt';

import {
  TXTMOB_Our_Software_is_only_permitted_ELL,
  TXTWCL_AAMS_were_unable_to_provide_a__ELL,
  TXTWCL_Account_already_exists,
  TXTWCL_Continue,
  TXTWCL_Error_Code_N0,
  TXTWCL_Fiscal_code_is_not_valid,
  TXTWCL_For_more_informationX_visit_ou_ELL_1,
  TXTWCL_Information_is_invalid,
  TXTWCL_Player_is_under_age,
  TXTWCL_Please_be_patient_or_try_again_ELL,
  TXTWCL_Please_try_again,
  TXTWCL_Please_update_the_Fiscal_code__ELL,
  TXTWCL_Please_update_your_province_in_ELL,
  TXTWCL_Province_of_residence_is_not_v_ELL,
  TXTWCL_Request_is_still_being_process_ELL,
  TXTWCL_Should_you_require_assistance__ELL,
  TXTWCL_Temporary_technical_issue,
  TXTWCL_The_fiscal_code_you_have_enter_ELL,
  TXTWCL_The_province_of_residence_you__ELL,
  TXTWCL_There_is_a_temporary_technical_ELL,
  TXTWCL_There_is_most_likely_a_slow_co_ELL,
  TXTWCL_This_error_indicates_that_you__ELL,
  TXTWCL_Unable_to_verify,
  TXTWCL_Unsuccessful_match,
  TXTWCL_We_were_unable_to_verify_your__ELL,
  TXTWCL_You_can_check_exactly_how_your_ELL,
  TXTWCL_Your_details_MUST_be_submitted_ELL
} from './AAMSErrors.messages.json';

interface Props {
  onClose(): void;
  code: string;
}

const AAMSErrors: React.FC<Props> = ({ onClose, code }) => {
  const openWindowContactSupport = useOpenWindow({ resolverTag: ResolverTag.HelpCenter });

  const renderBody = () => {
    switch (true) {
      case code === AamsErrorCode.TEMPORARY_TECHNICAL_ISSUE:
        return (
          <>
            <Typography>
              <Translation {...TXTWCL_Temporary_technical_issue} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_There_is_a_temporary_technical_ELL} />{' '}
              <Translation {...TXTWCL_Please_try_again} />
            </Typography>
          </>
        );
      case code === AamsErrorCode.REQUEST_STILL_BEING_PROCESSED:
        return (
          <>
            <Typography>
              <Translation {...TXTWCL_Request_is_still_being_process_ELL} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_There_is_most_likely_a_slow_co_ELL} />{' '}
              <Translation {...TXTWCL_Please_be_patient_or_try_again_ELL} />
            </Typography>
          </>
        );
      case code === AamsErrorCode.ACCOUNT_ALREADY_EXISTS:
      case code === AamsErrorCode.ACCOUNT_ALREADY_EXISTS_ONE:
        return (
          <>
            <Typography>
              <Translation {...TXTWCL_Account_already_exists} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_This_error_indicates_that_you__ELL} />{' '}
            </Typography>
            <Typography>
              <Translation
                {...TXTWCL_Should_you_require_assistance__ELL}
                values={{
                  a: (msg: string) => (
                    <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
                  )
                }}
              />
            </Typography>
          </>
        );
      case code === AamsErrorCode.PROVINCE_OF_RESIDENCE_NOT_VALID:
        return (
          <>
            <Typography>
              <Translation {...TXTWCL_Province_of_residence_is_not_v_ELL} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_The_province_of_residence_you__ELL} />{' '}
              <Translation {...TXTWCL_Please_update_your_province_in_ELL} />
            </Typography>
          </>
        );
      case code === AamsErrorCode.UNSUCCESSFUL_MATCH:
        return (
          <>
            <Typography>
              <Translation {...TXTWCL_Unsuccessful_match} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_AAMS_were_unable_to_provide_a__ELL} />{' '}
              <Translation {...TXTWCL_Your_details_MUST_be_submitted_ELL} />{' '}
              <Translation
                {...TXTWCL_You_can_check_exactly_how_your_ELL}
                values={{
                  a: (msg: string) => (
                    <ResolverLink resolverTag={ResolverTag.WrmfTelematiciFiscal}>
                      {msg}
                    </ResolverLink>
                  )
                }}
              />
            </Typography>
          </>
        );
      case code === AamsErrorCode.PLAYER_UNDER_AGE:
        return (
          <>
            <Typography>
              <Translation {...TXTWCL_Player_is_under_age} />
            </Typography>
            <Typography>
              <Translation {...TXTMOB_Our_Software_is_only_permitted_ELL} />
            </Typography>
          </>
        );
      case code === AamsErrorCode.INFORMATION_IS_INVALID:
        return (
          <>
            <Typography>
              <Translation {...TXTWCL_Information_is_invalid} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_AAMS_were_unable_to_provide_a__ELL} />{' '}
              <Translation {...TXTWCL_Your_details_MUST_be_submitted_ELL} />{' '}
              <Translation
                {...TXTWCL_You_can_check_exactly_how_your_ELL}
                values={{
                  a: (msg: string) => (
                    <ResolverLink resolverTag={ResolverTag.WrmfTelematiciFiscal}>
                      {msg}
                    </ResolverLink>
                  )
                }}
              />
            </Typography>
          </>
        );
      case code === AamsErrorCode.FISCAL_CODE_IS_NOT_VALID:
        return (
          <>
            <Typography>
              <Translation {...TXTWCL_Fiscal_code_is_not_valid} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_The_fiscal_code_you_have_enter_ELL} />{' '}
              <Translation {...TXTWCL_Please_update_the_Fiscal_code__ELL} />
            </Typography>
          </>
        );
      default:
        return (
          <Typography>
            <Translation {...TXTWCL_We_were_unable_to_verify_your__ELL} />
          </Typography>
        );
    }
  };

  return (
    <Prompt
      onClose={onClose}
      primaryButton={{ translation: TXTWCL_Continue }}
      variant="default"
      title={
        code !== AamsErrorCode.UNKNOWN_AAMS_ERROR
          ? {
              translation: TXTWCL_Error_Code_N0,
              values: { 0: code }
            }
          : {
              translation: TXTWCL_Unable_to_verify
            }
      }
    >
      {renderBody()}
      {code !== 'itAccountAlreadyExists' && (
        <Typography>
          <Translation
            {...TXTWCL_For_more_informationX_visit_ou_ELL_1}
            values={{ a: translatedLink({ onClick: openWindowContactSupport }) }}
          />
        </Typography>
      )}
    </Prompt>
  );
};

export default AAMSErrors;
